module.exports = __webpack_public_path__ + "static/media/promotionNews2.cb59aa5c.png";